import type { BidiInstance, TextDirection } from '../types';
import { isRTLLevel } from '../utils/level-utils';

/**
 * Phase 1: Character-Level Analysis
 *
 * Apply Unicode Bidirectional Algorithm for character-level analysis.
 * This determines the embedding levels and paragraph direction for each character.
 */

export const analyzeCharacters = (
  text: string,
  textDirection: TextDirection,
  bidi: BidiInstance,
) => {
  // Apply Unicode Bidirectional Algorithm for character-level analysis
  const embeddingLevels = bidi.getEmbeddingLevels(text, textDirection);
  const { paragraphs } = embeddingLevels;
  const paragraphDirection: TextDirection = isRTLLevel(paragraphs[0]?.level)
    ? 'rtl'
    : 'ltr';

  return {
    embeddingLevels,
    paragraphDirection,
  };
};
